<template>
  <v-list-item @click="downloadData" :loading="loading" :elevation="elevation">
    <template #append>
      <v-progress-circular indeterminate v-if="loading" size="24" width="3" />
      <v-icon v-else>mdi-download</v-icon>
    </template>

      <v-list-item-title style="white-space: normal;">
        {{ title ?? 'Herunterladen' }}
      </v-list-item-title>

  </v-list-item>
</template>

<script setup lang="ts">
import {getData} from '@/api/module/dms';
import {openBlob} from '@/util';
import {ref} from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: false,
  },
  token: {
    type: String,
    required: true,
  },
  fileName: {
    type: String,
    required: true,
  },
  elevation: {
    type: Number,
    default: 0,
  },
});
const loading = ref(false);
async function downloadData() {
  loading.value = true;
  const data: Blob = await getData(props.token);
  loading.value = false;
  await openBlob(data, props.fileName);
}

defineExpose({
  downloadData,
  loading,
});
</script>
